import { WorkingArea } from '@/constants/user/userWorkingArea'

type WorkingAreaFlags = Record<WorkingArea, boolean>

/**
 * A simple typing to make using the matchByWorkingArea function cleaner to use
 */
type SimpleWorkingAreaFlags = {
	unknown?: boolean
	tvAndFilm?: boolean
	advertising?: boolean
	brandsAndBusiness?: boolean
	audioEntertainment?: boolean
	games?: boolean
	individualCreator?: boolean
	other?: boolean
}

const mapToWorkingAreaFlags = (
	simple: SimpleWorkingAreaFlags
): WorkingAreaFlags => ({
	[WorkingArea.Unknown]: simple.unknown ?? false,
	[WorkingArea['TV & Film']]: simple.tvAndFilm ?? false,
	[WorkingArea.Advertising]: simple.advertising ?? false,
	[WorkingArea['Brands & Business']]: simple.brandsAndBusiness ?? false,
	[WorkingArea['Audio Entertainment']]: simple.audioEntertainment ?? false,
	[WorkingArea.Games]: simple.games ?? false,
	[WorkingArea['Individual Creator']]: simple.individualCreator ?? false,
	[WorkingArea.Other]: simple.other ?? false,
})

const matchByWorkingArea = (
	user: User,
	workingAreas: SimpleWorkingAreaFlags
): boolean => {
	if (!user) {
		return false
	}

	const { workingArea } = user
	const mappedFlags = mapToWorkingAreaFlags(workingAreas)

	return mappedFlags[workingArea as keyof WorkingAreaFlags] === true
}

export default matchByWorkingArea
